import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/sobre-nosotros',
      name: 'sobre-nosotros',
      component: () => import('../views/SobreNosotrosView.vue')
    },
    {
      path: '/nuestras-practicas',
      name: 'nuestras-practicas',
      component: () => import('../views/NuestrasPracticasView.vue')
    },
    {
      path: '/horarios-actividades',
      name: 'horarios-actividades',
      component: () => import('../views/HorariosActividadesView.vue')
    },
    {
      path: '/retiros',
      name: 'retiros',
      component: () => import('../views/RetirosView.vue')
    },
    {
      path: '/blog',
      name: 'blog',
      component: () => import('../views/BlogView.vue')
    },
    {
      path: '/blog/:slug',
      name: 'post',
      component: () => import('../views/PostView.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../views/AdminView.vue')
    },
    {
      path: '/contacto',
      name: 'contacto',
      component: () => import('../views/ContactoView.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
